// extracted by mini-css-extract-plugin
module.exports = {"selectedTrackColor":"#f36a10","unselectedTrackColor":"#707070"};